const localizers = {
  'loading.msg': () => `Ladataan...`,
  'SASServer.genericError.msg': () => `Palvelimeen ei saada yhteyttä.`,
  'SASReport.genericError.msg': () => `Valittua raporttia ei voi ladata.`,
  'SASReportImage.genericError.msg': () => `Raportin kuvan lataaminen epäonnistui.`,
  'SASReportImage.imageNotSupported.msg': () => `Kuvia ei tueta tässä raportin sisältötyypissä.`,
}
export default localizers;
